import { useMutation, useQueryClient } from '@tanstack/react-query';
import { educationService } from '../services/education.service';
import type { CreateEducationRequest } from '../types/education.types';

interface CreateEducationParams {
  candidateId: string;
  request: CreateEducationRequest;
}

export function useCreateEducation(): {
  createEducation: (params: CreateEducationParams) => void;
  isLoading: boolean;
} {
  const queryClient = useQueryClient();

  const { mutate: createEducation, isPending: isLoading } = useMutation({
    mutationFn: ({ candidateId, request }: CreateEducationParams) =>
      educationService.create(candidateId, request),
    onSuccess: (_data, { candidateId }) => {
      queryClient.invalidateQueries({ queryKey: ['educations', candidateId] });
    },
  });

  return { createEducation, isLoading };
}
